import { ProfileTypeOf } from "@modules/profile/profileTypes"
import { Program } from "@modules/programs/programTypes"
import { ScoreType } from "@modules/scoreboard/scoreTypes"
import { HUImage } from "@modules/types/imageTypes"

export type PublicProfile = {
  id: string
  userId: string
  _type: typeof ProfileTypeOf
  username: string
  firstname?: string
  lastname?: string
  biography?: string
  avatar?: HUImage
  birthDate?: Date
  crossfitStartDate?: string
  genderCategory?: string
  job?: string
  nationality?: string
  height?: number
  weight?: number
  favoritesPersonalRecords: FavoritesPersonalRecord[]
  ownedPrograms: Program[]
  followedPrograms: Program[]
  sharedCoachPrograms: Program[]
  badges: UserBadge[]
}

export type FavoritesPersonalRecord = {
  movement: Movement
  personalRecord: PersonalRecord
  favorite: boolean
}

export type Movement = {
  id: string
  movementName: string
  description: string
  modality: Modality
  scoreType: ScoreType
  videoUrl?: string
}

export type UserBadge = {
  userBadgeId: string
  badge: Badge
  additionalInformation?: string
  date: string
}

export type Badge = {
  id: string
  name: string
  code: string
  date: Date
  obtainable: boolean
  image: HUImage
}

export type PersonalRecord = {
  id: string
  movementId: string
  value: number
  repetitionMax?: number
  date: Date
  comment?: string
}

export enum Modality {
  WEIGHT_LIFTING = "WEIGHT_LIFTING",
  METCON = "METCON",
  GYM = "GYM ",
}
